import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/projects`. Only redirects: `/projects` checks its own access.
export const Route = createFileRoute('/_authenticated/rfqs')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/projects', replace: true });
    },
});
